import { Stack } from '@mui/material'

import { CreateTemplateDialog } from '@/pages/template-payments/components/create-template-dialog.tsx'
import { useMutatePersonalSettings } from '@/services'
import { PersonCustomizationDialog } from '@/components/person-customization-dialog.tsx'
import { RowProps } from '@/components/dnd-area/draggable-row.tsx'
import { useAppSelector } from '@/stores/hooks.ts'
import { userSelectors } from '@/stores/slices/user-slice.ts'

import { KEY_PAGE, defaultSettings, PartialTemplates } from '../default-settings.tsx'

export const TemplateActions = () => {
  const settings = useAppSelector((state) => userSelectors.personalSettings(state, KEY_PAGE))

  const getSettings = (format: string, personalSettings?: Record<string, string[]>) => {
    const settingsByRequest = personalSettings?.[format] ?? Object.keys(defaultSettings)
    const settings: RowProps[] = settingsByRequest.map((e) => ({
      id: e,
      label: defaultSettings[e as keyof PartialTemplates],
      isChecked: true,
    }))
    Object.keys(defaultSettings).forEach((key) => {
      if (!settingsByRequest.includes(key)) {
        settings.push({ id: key, label: defaultSettings[key as keyof PartialTemplates], isChecked: false })
      }
    })

    return settings
  }

  return (
    <Stack
      direction={{ sm: 'column', px526: 'row' }}
      gap={2}
      justifyContent={{ sm: 'flex-start', px526: 'flex-end' }}
      alignItems="flex-start"
    >
      <CreateTemplateDialog />
      <PersonCustomizationDialog
        personalSettingsKey={KEY_PAGE}
        mutation={useMutatePersonalSettings()}
        itemsDesktop={getSettings('desktop', settings)}
        itemsMobile={getSettings('mobile', settings)}
      />
    </Stack>
  )
}
